module.exports = __webpack_public_path__ + "aa4c72eb5d8bc3ff6d5ea7bee275467c.png";


//////////////////
// WEBPACK FOOTER
// ./components/layout/Header/flag-en.png
// module id = DVzP
// module chunks = 0